import { IGroup, IGroupCreate, IGroupUpdate } from '../typing/group.interface';

export class Group {
    data: IGroup;

    constructor(data: IGroup){
        this.data = data;
    }

    dataForCreate(formData: IGroupCreate): IGroupCreate{
        return {
            name: formData.name,
            // companyId: formData.companyId,
            locationId: formData.locationId,
        };
    }

    dataForUpdate(formData: IGroupCreate): IGroupUpdate {
        return {
            id: this.data.id,
            name: formData.name,
            // companyId: formData.companyId,
            locationId: formData.locationId,
        };
    }

    formData(): IGroupCreate {
        return {
            name: this.data.name,
            // companyId: this.data.company?.id,
            locationId: this.data.location?.id,
        };
    }
}
